import { render } from "./AnimalCount.vue?vue&type=template&id=2d3733ea&scoped=true"
import script from "./AnimalCount.vue?vue&type=script&lang=js"
export * from "./AnimalCount.vue?vue&type=script&lang=js"

import "./AnimalCount.vue?vue&type=style&index=0&id=2d3733ea&scoped=true&lang=css"

import exportComponent from "/Users/chordarts/pasti/dev10/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d3733ea"]])

export default __exports__